import Vue from 'vue'
import VueRouter from 'vue-router'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/home/index.vue'),
    meta: {
      title: '首页'
    }
  },
  {
    path: '/person',
    name: 'Person',
    component: () => import('@/views/person/index.vue'),
    meta: {
      title: '关于我们'
    }
  },
  {
    path: '/policy',
    name: 'policy',
    component: () => import('@/layout/main.vue'),
    redirect: '/policy/centre',
    meta: {
      title: '政策法规'
    },
    children: [
      {
        path: 'centre',
        name: 'centre',
        component: () => import('@/views/policy/centre/index.vue'),
        meta: {
          title: '中央'
        }
      },
      {
        path: 'education',
        name: 'education',
        component: () => import('@/views/policy/education/index.vue'),
        meta: {
          title: '教育部'
        }
      },
      {
        path: 'other',
        name: 'other',
        component: () => import('@/views/policy/other/index.vue'),
        meta: {
          title: '其他'
        }
      }
    ]
  },
  {
    path: '/study',
    name: 'study',
    redirect: '/study/higher',
    component: () => import('@/layout/main.vue'),
    meta: {
      title: '理论研究'
    },
    children: [
      {
        path: 'higher',
        name: 'higher',
        component: () => import('@/views/study/higher/index.vue'),
        meta: {
          title: '高职'
        }
      },
      {
        path: 'secondary',
        name: 'secondary',
        component: () => import('@/views/study/secondary/index.vue'),
        meta: {
          title: '中职'
        }
      }
    ]
  },
  {
    path: '/information',
    name: 'information',
    redirect: '/information/news',
    component: () => import('@/layout/main.vue'),
    meta: {
      title: '重要资讯'
    },
    children: [
      {
        path: 'news',
        name: 'news',
        component: () => import('@/views/information/news/index.vue'),
        meta: {
          title: '新闻要闻'
        }
      },
      {
        path: 'comprehensive',
        name: 'comprehensive',
        component: () => import('@/views/information/comprehensive/index.vue'),
        meta: {
          title: '综合资讯'
        }
      }
    ]
  },
  {
    path: '/expert',
    name: 'Expert',
    component: () => import('@/views/expert/index.vue'),
    meta: {
      title: '专家库'
    }
  },
  {
    path: '/education',
    name: 'education',
    redirect: '/education/school',
    component: () => import('@/layout/main.vue'),
    meta: {
      title: '职教风采'
    },
    children: [
      {
        path: 'school',
        name: 'school',
        component: () => import('@/views/education/school/index.vue'),
        meta: {
          title: '学校风采'
        }
      },
      {
        path: 'teacher',
        name: 'teacher',
        component: () => import('@/views/education/teacher/index.vue'),
        meta: {
          title: '教师风采'
        }
      },
      {
        path: 'student',
        name: 'student',
        component: () => import('@/views/education/student/index.vue'),
        meta: {
          title: '学生风采'
        }
      }
    ]
  },
  {
    path: '/train',
    name: 'train',
    component: () => import('@/views/train/index.vue'),
    meta: {
      title: '研修培训'
    }
  },
  {
    path: '/course',
    name: 'course',
    redirect: '/course/free',
    component: () => import('@/layout/main.vue'),
    meta: {
      title: '网上课程'
    },
    children: [
      {
        path: 'free',
        name: 'free',
        component: () => import('@/views/course/free/index.vue'),
        meta: {
          title: '免费课程'
        }
      },
      {
        path: 'charge',
        name: 'charge',
        component: () => import('@/views/course/charge/index.vue'),
        meta: {
          title: '收费课程'
        }
      }
    ]
  },
  {
    path: '/certificate',
    name: 'certificate',
    component: () => import('@/views/certificate/index.vue'),
    meta: {
      title: '证书查询'
    }
  },
  {
    path: '/detail',
    name: 'detail',
    meta: {
      title: '详情'
    },
    component: () => import('@/views/detail/index.vue'),
    hidden: true
  }
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
})

router.onError((err) => {
  // debugger
  console.error(err, '----router错误')
})

export default router
